import Button from "@material-ui/core/Button/Button";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Hidden from '@material-ui/core/Hidden';
import TextField from '@material-ui/core/TextField/TextField';
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Keyboard from "@material-ui/icons/Keyboard";
import Search from "@material-ui/icons/Search";
import DatePicker from 'material-ui-pickers/DatePicker';
import { parse } from "query-string";
import * as React from "react";
import { RouteComponentProps, Link } from 'react-router-dom';
import { Content } from "../components/content";
import { ContentTypePicker } from "../components/content-type-picker";
import { findTagsHelper, resolveTagsHelper, findPeopleHelper, resolvePeopleHelper} from "../components/forms/form-state-helper";
import { GlobalSearchResultList } from "../components/global-search-result-list";
import TagListEditor from "../components/material/tag-list-editor";
import { IAuthContextProps, withAuthContext } from "../components/with-auth-context";
import { ISnackbarContextProps, withSnackbar } from "../components/with-snackbar";
import { GlobalAdvancedSearchInputModel } from "../model/autogen/GlobalAdvancedSearchInputModel";
import { GlobalSearchResultModel } from "../model/autogen/GlobalSearchResultModel";
import { TagModel } from "../model/autogen/TagModel";
import Typography from "@material-ui/core/Typography/Typography";
import Paper from "@material-ui/core/Paper/Paper";
import { RoutePaths } from "../route-paths";
import { DATE_DISPLAY_FORMAT } from "../components/date-display-format";
import * as moment from "moment";
import { strIsNullOrEmpty } from "../utils/string";
import { InfiniteListLoading, InfiniteScrollerHelper } from "./infinite-scroller-helper";
import { SearchableContentType } from "../model/autogen/SearchableContentType";
import PersonListEditor from "components/material/person-list-editor";
import { PersonInfo } from "model/autogen/PersonInfo";
import { PeopleList } from "components/material/people-list";
// import { TwitterHandleModel } from "model/autogen/TwitterHandleModel";
// import { TwitterHandleList } from "components/material/twitter-handle-list";
// import { PersonModel } from "model/autogen/PersonModel";
import { Iif } from "components/iif";
import { AbstractDocumentKind } from "../model/autogen/AbstractDocumentKind";

export function isValidContentType(str: any): str is SearchableContentType {
    switch (str) {
        case SearchableContentType.FAQ:
        case SearchableContentType.IssueBrief:
        case SearchableContentType.Achievement:
        case SearchableContentType.ProfileOfMP:
        case SearchableContentType.DebateNotes:
        case SearchableContentType.MediaLines:
        case SearchableContentType.OpinionEditorial:
        case SearchableContentType.Quote:
        case SearchableContentType.Resource:
        //case SearchableContentType.Tweet:
            return true;
    }
    return false;
}

export interface ISearchState extends GlobalAdvancedSearchInputModel {
    isSearching: boolean;
    isPickingAuthor: boolean;
    results: GlobalSearchResultModel | undefined;
}

interface IHasMoreState {
    hasMore?: boolean
}

type IAllSearchState = IHasMoreState & ISearchState;

const EMPTY_TAGS_ARRAY = [] as string[];

export interface IAdvancedSearchComponentProps {
    deletedOnly?: boolean;
}

export type AdvancedSearchComponentProps = IAdvancedSearchComponentProps & RouteComponentProps<any> & IAuthContextProps & ISnackbarContextProps;

export class AdvancedSearchComponent extends React.Component<AdvancedSearchComponentProps, IAllSearchState> {
    private helper: InfiniteScrollerHelper;
    constructor(props: AdvancedSearchComponentProps) {
        super(props);
        this.helper = new InfiniteScrollerHelper(
            () => this.state,
            (newState, callback) => this.setState(newState, callback),
            () => this.props
        );
        this.state = {
            ...this.helper.getInitialState(),
            isSearching: false,
            results: undefined,
            startAt: undefined,
            hasMore: false,
            isPickingAuthor: false,
        };
    }
    componentDidMount() {
        if (this.props.location.search) {
            const { type, autoSearch } = parse(this.props.location.search);
            if (isValidContentType(type)) {
                this.setState({
                    documentTypes: [type]
                }, () => {
                    if (autoSearch == "1") {
                        this.search();
                    }
                });
            }
        };
    }
    // bs
    private onContentTypeChanged = (ct: SearchableContentType) => {
        this.setState({ documentTypes: strIsNullOrEmpty(ct.toString()) ? [] : [ct] });
    }
    private search = (startingCount?: number) => {
        this.helper.performSearch(startingCount);
    }
    private onQueryChanged = (e: any) => {
        this.setState({ query: e.target.value });
    }
    private onTagsChanged = (tags: TagModel[]) => {
        this.setState({ tags: tags });
    }
    private onSearchTags = (query: string, isResourceOnly: boolean) => {
        return findTagsHelper(this.props.callApi, query, isResourceOnly);
    }
    private onResolveTags = (tags: string[]) => {
        return resolveTagsHelper(this.props.callApi, tags);
    }
    private onFromChanged = (newDate: moment.Moment) => {
        this.setState({ from: newDate ? newDate.utc().toISOString() : null });
    }
    private onToChanged = (newDate: moment.Moment) => {
        this.setState({ to: newDate ? newDate.utc().toISOString() : null });
    }
    private getMoreResults = () => {
        this.helper.fetchMoreResults();
    }

    private onFetchPeople = (query: string) => {
        return findPeopleHelper(this.props.callApi, query)
    }
    private onResolvePeople = (peopleIds: number[]) => {
        return resolvePeopleHelper(this.props.callApi, peopleIds);
    }
    private onPeopleChanged = (searchedSubjects: PersonInfo[]) => {
        let { quoteSubjects } = this.state;
        quoteSubjects = searchedSubjects;
        this.setState({ quoteSubjects });
    }

    private onQuoteAuthorSelected = (person: PersonInfo | undefined) => {
        let { quoteAuthor } = this.state
        person ? quoteAuthor = person : quoteAuthor = undefined;
        this.setState({quoteAuthor})
    }
    private onQuoteAuthorSubjectSelected = (person: PersonInfo | undefined) => {
        let { quoteAuthoredSubject } = this.state
        person ? quoteAuthoredSubject = person : quoteAuthoredSubject = undefined;
        this.setState({quoteAuthoredSubject})
    }

    // private onTweetAuthorSelected = (tweeter: TwitterHandleModel | undefined) => {
    //     let { tweetAuthor } = this.state
    //     tweeter ? tweetAuthor = tweeter : tweetAuthor = undefined;
    //     this.setState({tweetAuthor})
    // }

    // private onTweetAuthoredMentionSelected = (tweeter: TwitterHandleModel | undefined) => {
    //     let { tweetAuthoredMention } = this.state
    //     tweeter ? tweetAuthoredMention = tweeter : tweetAuthoredMention = undefined;
    //     this.setState({tweetAuthoredMention})
    // }

    // private onTwitterHandlesChanged = (people: PersonModel[]) => {
    //     let handles = people.map(p => p.twitterHandles[0])
    //     let { tweetMentions } = this.state;
    //     tweetMentions = handles;
    //     this.setState({ tweetMentions });
    // }

    public render() {
        const quoteExtras = <div>
            <PeopleList {...this.props} onPersonSelected={this.onQuoteAuthorSelected} label={"an Author"} classes/>
            <PersonListEditor tweet={false} label="Transcript Subjects" initialPeopleIds={[]} onFetchPeople={this.onFetchPeople} onResolvePeople={this.onResolvePeople} onPeopleChanged={this.onPeopleChanged}/>
            <PeopleList {...this.props} onPersonSelected={this.onQuoteAuthorSubjectSelected} label={"an Author and Subject"} classes/>
        </div>
        // const tweetExtras = <div>
        //     <TwitterHandleList {...this.props} onTwitterHandleSelected={this.onTweetAuthorSelected} label={"an Author"} classes/>
        //     <PersonListEditor label="Tweet Mentions" initialPeopleIds={[]} onFetchPeople={this.onFetchPeople} onResolvePeople={this.onResolvePeople} onPeopleChanged={this.onTwitterHandlesChanged} tweet={true}/>
        //     <TwitterHandleList {...this.props} onTwitterHandleSelected={this.onTweetAuthoredMentionSelected} label={"an Author or Mentions"} classes/>
        // </div>
        const formContent = <div>
            <ContentTypePicker dataEntry={false} label="Content Type" name="content-type" contentType={this.state.documentTypes[0] as SearchableContentType} onChange={this.onContentTypeChanged} />
            {this.state.documentTypes[0] === SearchableContentType.Quote && quoteExtras}
            {/* {this.state.documentTypes[0] === "Tweet" && tweetExtras} */}
            <DatePicker format={DATE_DISPLAY_FORMAT} label="Date From" autoOk clearable showTodayButton value={this.state.from} onChange={this.onFromChanged} leftArrowIcon={<ChevronLeft />} rightArrowIcon={<ChevronRight />} keyboardIcon={<Keyboard />} />
            <DatePicker format={DATE_DISPLAY_FORMAT} label="Date To" autoOk clearable showTodayButton value={this.state.to} onChange={this.onToChanged} leftArrowIcon={<ChevronLeft />} rightArrowIcon={<ChevronRight />} keyboardIcon={<Keyboard />} />
            <Iif show={this.state.documentTypes[0] !== "Tweet"}>
                <div style={{ marginTop: 10 }}>
                    <TagListEditor isResourceOnly={this.state.documentTypes.indexOf(`${AbstractDocumentKind.Resource}`) >= 0} classes={{}} initialTags={EMPTY_TAGS_ARRAY} onTagsChanged={this.onTagsChanged} onFetchTags={this.onSearchTags} onResolveTags={this.onResolveTags} />
                </div>
            </Iif>
        </div>;
        return <Content>
            <form autoComplete="off">
                {this.props.deletedOnly === true && <Paper>
                    <Typography variant="subtitle1">This search only covers <strong>Archived Content</strong>. For non-archived content, use <Link to={RoutePaths.AdvancedSearch}>normal search</Link></Typography>
                </Paper>}
                <TextField label="Search terms" fullWidth={true} value={this.state.query} onChange={this.onQueryChanged} />
                <Hidden smUp>
                    <ExpansionPanel style={{ marginTop: '30px' }}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            More Filters
                    </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            {formContent}
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <br />
                </Hidden>
                <Hidden only="xs">
                    {formContent}
                </Hidden>
                <Button style={{marginTop: "10px"}} disabled={this.state.isSearching} variant="contained" onClick={() => this.search(0)} fullWidth><Search /> {this.state.isSearching ? "Searching..." : "Search"}</Button>
                <InfiniteListLoading isSearching={this.state.isSearching} startAt={this.state.startAt} results={this.state.results}>
                    <GlobalSearchResultList hasMore={this.state.hasMore} requestMoreResults={this.getMoreResults} deletedOnly={this.props.deletedOnly} results={this.state.results!} />
                </InfiniteListLoading>
            </form>
        </Content>;
    }
}

export const  AdvancedSearch = withSnackbar(withAuthContext(AdvancedSearchComponent));


// WEBPACK FOOTER //
// ./src/pages/advanced-search.tsx